// pauseUploadJobs.js
'use strict';
import setUploadJobStatus from '../action/setUploadJobStatus.js';

import getOperationData from '../selector/getOperationData.js';

import uploadJobReferences from '../resource/uploadJobReferences.js';
import { Status as UploadStatus } from '../resource/uploadConstants.js';
import { ArtifactType } from '../resource/assetConstants.js';

/**
 * Pause upload jobs
 * @kind action
 * @param {[]<string>} {uploadJobIds} - upload job ids.
 * @return {Promise} Action promise.
 */
const pauseUploadJobs =
  ({ uploadJobIds = [] }) =>
  async (dispatch, getState) => {
    uploadJobIds.forEach(uploadJobId => {
      const assetIds =
        getOperationData(getState(), ['uploadJob', uploadJobId], 'assetIds') ||
        [];
      assetIds.forEach(assetId => {
        const xhr = uploadJobReferences.get(`${assetId}:media:xhr`);
        if (xhr) {
          xhr.abort();
        }
        Object.values(ArtifactType).forEach(type => {
          const xhr = uploadJobReferences.get(`${assetId}:${type}:xhr`);
          if (xhr) {
            xhr.abort();
          }
        });
      });
      dispatch(
        setUploadJobStatus({
          uploadJobId,
          status: UploadStatus.UPLOAD_FAILED,
          failedReason: 'User abort upload',
        })
      );
    });
  };

export default pauseUploadJobs;
